import isEmpty from "lodash.isempty";

export const getUserDisplay = (user?: Partial<User>): string | undefined => {
  const { name, surname, email } = user || {};

  return user
    ? name || surname
      ? `${name || ""}${name && surname ? " " : ""}${surname || ""}`
      : email
    : undefined;
};

export const getUserDisplayEmail = (user?: Partial<User>): string => {
  const { name, surname, email } = user || {};

  if (!isEmpty(name) || !isEmpty(surname)) {
    return `${getUserDisplay(user)} (${email})`;
  }

  return `(${email})`;
};
